var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.227,12C51.146,12,52,12.854,52,23.773v16.453C52,51.145,51.146,52,40.227,52H23.773C12.854,52,12,51.145,12,40.227 V23.773C12,12.854,12.854,12,23.773,12H40.227z M26.285,39.41c4.092,0,7.41-3.318,7.41-7.41c0-4.092-3.318-7.41-7.41-7.41 c-4.092,0-7.41,3.318-7.41,7.41C18.875,36.092,22.193,39.41,26.285,39.41z M38.103,39.052c2.026,0,3.667-3.157,3.667-7.052 c0-3.895-1.642-7.052-3.667-7.052S34.436,28.105,34.436,32C34.436,35.894,36.078,39.052,38.103,39.052z M43.8,38.299 c0.704,0,1.275-2.82,1.275-6.299s-0.571-6.299-1.275-6.299c-0.705,0-1.276,2.82-1.276,6.299S43.096,38.299,43.8,38.299z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.3ab1e21b9efe9615df9ac70933eff0ee.svg";
export { ForwardRef as ReactComponent };